import _ from "lodash";

/**
 * Returns file type mappings for a selected creditor from the list of creditors and profiles
 * @param creditorsAndProfiles Array of creditors and their profile mappings
 * @param selectedCreditorId The ID of the selected creditor
 * @returns Array of file type mappings for the selected creditor
 */
export const getFileTypeMappings = (
  creditorsAndProfiles: any[],
  selectedCreditorId: number
) => {
  try {
    // Find the selected creditor in the array
    const selectedCreditor = _.find(creditorsAndProfiles, {
      creditorId: selectedCreditorId,
    });

    // Return the file type mappings if the creditor exists, otherwise return empty array
    return selectedCreditor?.fileTypeMappings || [];
  } catch (error) {
    return [];
  }
};
